import VisitsApiPaths from 'Application/Visits/Constants/VisitsApiPaths'
import React, { useEffect, useState } from 'react'
import { instance, podInstance } from 'Services/instance'
import Const from 'Utils/Consts';

interface IProps {
    isPodSpace: boolean
    className: string
    styles?: any
    hashFile?: string
    fileId?: number
    fileContent?: string
    onLoad?: (data: string) => void
    children?: any
}

const PodSpaceImage = (props: IProps) => {
    const [loaded, setLoaded] = useState<boolean>(false);
    const [downloadLink, setDownloadLink] = useState<string | null>(null);
    const [fileContent, setFileContent] = useState<string | null>(null);
    // useEffect(() => {
    //     if (props.fileContent) {
    //         setFileContent(props.fileContent)
    //     }
    //     else if (!loaded && props.hashFile) {
    //         getDownloadLink();
    //     }
    // }, [])

    useEffect(() => {
        if (props.fileContent) {
            setFileContent(props.fileContent)
        }
        else if (!loaded) {
            if (props.isPodSpace) {
                if (props.hashFile)
                    getDownloadLink();
            }
            else {
                if (props.fileId)
                    getImage(props.fileId)
            }
        }
    }, [props.hashFile, props.fileId, props.fileContent])

    useEffect(() => {
        if (!loaded && downloadLink)
            getPodSpaceImage();
    }, [downloadLink])

    const getDownloadLink = async () => {
        await instance.get(`${VisitsApiPaths.GetDownloadLink}${props.hashFile}`, { timeout: 60000 })
            .then((res) => {
                if (res.status === 200) {
                    setDownloadLink(res.data)
                }
            })
            .catch((error) => {
                console.error(error)
            })
    }

    const getPodSpaceImage = async () => {
        await podInstance.get(`/links/${downloadLink}`, { timeout: 60000, responseType: 'arraybuffer' })
            .then((res) => {
                if (res.status === 200) {
                    let binary = ''
                    const bytes = new Uint8Array(res.data)
                    for (let i = 0; i < bytes.byteLength; i++)
                        binary += String.fromCharCode(bytes[i])
                    const base64String = window.btoa(binary)
                    if (props.onLoad)
                        props.onLoad(`data:${res.headers['content-type']};base64,${base64String}`)
                    setFileContent(`data:${res.headers['content-type']};base64,${base64String}`)
                    setLoaded(true)
                }
            })
            .catch((error) => {
            })
    }

    const getImage = async (fileId: any) => {
        await instance.get(`${Const.env.REACT_APP_API_GATEWAY_URL}${VisitsApiPaths.DownloadThumbnailFile}${fileId}`, { timeout: 60000, responseType: 'arraybuffer' })
            .then((res) => {
                if (res.status === 200) {
                    let binary = ''
                    const bytes = new Uint8Array(res.data)
                    for (let i = 0; i < bytes.byteLength; i++)
                        binary += String.fromCharCode(bytes[i])
                    const base64String = window.btoa(binary)
                    if (props.onLoad)
                        props.onLoad(`data:${res.headers['content-type']};base64,${base64String}`)
                    setFileContent(`data:${res.headers['content-type']};base64,${base64String}`)
                    setLoaded(true)
                }
            })
            .catch((error) => {
            })
    }

    return (
        <div className={props.className} style={{ ...props.styles, backgroundImage: `url(${fileContent})` }}>
            {props.children}
        </div>
    )
}

export default PodSpaceImage